import appConfig from '@/config.js'

/**
 * User preferences are stored in localStorage and synced through the user's profile
 * (meta.persistentStorage), which every product and ecosystem of the user shares.
 * To keep them apart they are stored as {product}.{ecosystem}.{type}, e.g.
 * carriers.12.tableFields.
 */
export const preferenceStorageKey = (type, eid) => `${appConfig.product}.${eid}.${type}`

// Preferences that used to be stored under the bare type key. generalMapPreferences is
// left out on purpose: its bare key belongs to GCM2's general map (other layers)
export const LEGACY_PREFERENCE_TYPES = ['tableFields', 'perPage', 'compact', 'autoApply']

const readLocal = (key) => {
  if (localStorage[key] === undefined) return undefined
  try {
    return JSON.parse(localStorage[key])
  } catch (e) {
    return localStorage[key]
  }
}

/**
 * Values to copy from the legacy (bare) keys to the scoped ones, for the types whose
 * scoped key doesn't exist yet. Legacy keys are kept: other products still read them.
 * @param {Object} persistentStorage - profile.meta.persistentStorage
 * @param {string|number} eid - current ecosystem id
 * @returns {Object} { [scopedKey]: value } (empty when there is nothing to migrate)
 */
export function legacyPreferencesToMigrate(persistentStorage, eid) {
  const migrated = {}
  if (!eid) return migrated

  for (const type of LEGACY_PREFERENCE_TYPES) {
    const scopedKey = preferenceStorageKey(type, eid)
    if (persistentStorage?.[scopedKey] !== undefined || readLocal(scopedKey) !== undefined) continue

    const legacyValue = persistentStorage?.[type] !== undefined ? persistentStorage[type] : readLocal(type)
    if (legacyValue !== undefined && legacyValue !== null) {
      migrated[scopedKey] = legacyValue
    }
  }
  return migrated
}
